import { ENTITY_TYPE, FLOW_TYPE, PATHS, PROCESS_STATUS } from 'consts';

const { AV, EB, ER, ES_MV, MV, RR_EB, RR_ER, RR_MV, RR_SU } = FLOW_TYPE;
const { INDIVIDUAL, LEGAL_ENTITY } = ENTITY_TYPE;

const {
	AML,
	APPROPRIATENESS,
	CREDIT_CHECK,
	FINISH,
	INTERESTS,
	MANDATE,
	NETBANK,
	ONBOARD,
	PARENTS,
	PRODUCTS,
	RISKQ_RESULTS,
	SIGN,
	SIGNING_AUTHORITY,
	SUITABILITY
} = PATHS;

export const PROCESS_STATUS_PAGES = {
	[PROCESS_STATUS.None]: {
		[AV]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[EB]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[ER]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[MV]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[ES_MV]: { [INDIVIDUAL]: [ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[RR_EB]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[RR_ER]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[RR_MV]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] },
		[RR_SU]: { [INDIVIDUAL]: [AML, ONBOARD], [LEGAL_ENTITY]: [ONBOARD] }
	},
	[PROCESS_STATUS.Started]: {
		[AV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[EB]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[ER]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[MV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[RR_ER]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[RR_MV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] },
		[RR_SU]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [AML] }
	},
	[PROCESS_STATUS.FinishedAML]: {
		[AV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[EB]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[ER]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[MV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[RR_ER]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[RR_MV]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] },
		[RR_SU]: { [INDIVIDUAL]: [APPROPRIATENESS], [LEGAL_ENTITY]: [APPROPRIATENESS] }
	},
	[PROCESS_STATUS.FinishedAppropriateness]: {
		[AV]: {
			[INDIVIDUAL]: [CREDIT_CHECK, PRODUCTS, MANDATE],
			[LEGAL_ENTITY]: [CREDIT_CHECK, PRODUCTS, MANDATE, SIGNING_AUTHORITY]
		},
		[EB]: { [INDIVIDUAL]: [SUITABILITY], [LEGAL_ENTITY]: [SUITABILITY] },
		[ER]: { [INDIVIDUAL]: [SUITABILITY], [LEGAL_ENTITY]: [SUITABILITY] },
		[MV]: {
			[INDIVIDUAL]: [MANDATE, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, SIGNING_AUTHORITY, SIGN]
		},
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [SUITABILITY], [LEGAL_ENTITY]: [SUITABILITY] },
		[RR_ER]: { [INDIVIDUAL]: [SUITABILITY], [LEGAL_ENTITY]: [SUITABILITY] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.FinishedSuitability]: {
		[AV]: {
			[INDIVIDUAL]: [CREDIT_CHECK, PRODUCTS, MANDATE],
			[LEGAL_ENTITY]: [CREDIT_CHECK, PRODUCTS, MANDATE, SIGNING_AUTHORITY]
		},
		[EB]: { [INDIVIDUAL]: [RISKQ_RESULTS], [LEGAL_ENTITY]: [RISKQ_RESULTS] },
		[ER]: {
			[INDIVIDUAL]: [MANDATE, INTERESTS, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN]
		},
		[MV]: {
			[INDIVIDUAL]: [MANDATE, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, SIGNING_AUTHORITY, SIGN]
		},
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [RISKQ_RESULTS], [LEGAL_ENTITY]: [RISKQ_RESULTS] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.SelectedRiskProfile]: {
		[AV]: {
			[INDIVIDUAL]: [CREDIT_CHECK, PRODUCTS, MANDATE],
			[LEGAL_ENTITY]: [CREDIT_CHECK, PRODUCTS, MANDATE, SIGNING_AUTHORITY]
		},
		[EB]: {
			[INDIVIDUAL]: [MANDATE, INTERESTS, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN]
		},
		[ER]: {
			[INDIVIDUAL]: [MANDATE, INTERESTS, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN]
		},
		[MV]: {
			[INDIVIDUAL]: [MANDATE, SIGN],
			[LEGAL_ENTITY]: [NETBANK, MANDATE, SIGNING_AUTHORITY, SIGN]
		},
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.FinishedNetbanki]: {
		[AV]: {
			[INDIVIDUAL]: [CREDIT_CHECK, PRODUCTS, MANDATE],
			[LEGAL_ENTITY]: [CREDIT_CHECK, PRODUCTS, MANDATE, SIGNING_AUTHORITY]
		},
		[EB]: {
			[INDIVIDUAL]: [MANDATE, INTERESTS, SIGN],
			[LEGAL_ENTITY]: [MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN]
		},
		[ER]: {
			[INDIVIDUAL]: [MANDATE, INTERESTS, SIGN],
			[LEGAL_ENTITY]: [MANDATE, INTERESTS, SIGNING_AUTHORITY, SIGN]
		},
		[MV]: { [INDIVIDUAL]: [MANDATE, SIGN], [LEGAL_ENTITY]: [MANDATE, SIGNING_AUTHORITY, SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [PARENTS, MANDATE], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.FinishedMandate]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[EB]: { [INDIVIDUAL]: [INTERESTS, SIGN], [LEGAL_ENTITY]: [INTERESTS, SIGNING_AUTHORITY, SIGN] },
		[ER]: { [INDIVIDUAL]: [INTERESTS, SIGN], [LEGAL_ENTITY]: [INTERESTS, SIGNING_AUTHORITY, SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.FinishedInterests]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGNING_AUTHORITY, SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.FinishedMembers]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.AddedDerivativesProduct]: {
		[AV]: { [INDIVIDUAL]: [MANDATE, SIGN], [LEGAL_ENTITY]: [MANDATE, SIGNING_AUTHORITY, SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.InSigning]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.PrintedContractForManualSigning]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.InProcessing]: {
		[AV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[EB]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ER]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [SIGN] },
		[ES_MV]: { [INDIVIDUAL]: [SIGN], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	},
	[PROCESS_STATUS.Finished]: {
		[AV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[ES_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [] },
		[RR_EB]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_ER]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_MV]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] },
		[RR_SU]: { [INDIVIDUAL]: [FINISH], [LEGAL_ENTITY]: [FINISH] }
	}
};
